"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function xMinutesAgo(dateStr) {
  var date = new Date(dateStr);
  var dateTime = date.getTime();

  if (isNaN(dateTime)) {
    return dateStr;
  }

  var now = Date.now();
  var deltaInMs = now - dateTime;
  var deltaInMinutes = Math.floor(deltaInMs / 60000);
  var deltaInHours = Math.floor(deltaInMs / 3600000);

  if (deltaInMinutes < 1) {
    return 'たった今';
  } else if (deltaInHours < 1) {
    return "".concat(deltaInMinutes, " \u5206\u524D");
  } else if (deltaInHours < 5) {
    return "".concat(deltaInHours, " \u6642\u9593\u524D");
  } else if (deltaInHours <= 24) {
    return '今日';
  } else if (deltaInHours <= 48) {
    return '昨日';
  } else if (window.Intl) {
    return new Intl.DateTimeFormat('ja-JP').format(date);
  } else {
    return date.toLocaleString('ja-JP', {
      day: '2-digit',
      hour: '2-digit',
      hour12: false,
      minute: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }
}

var _default = {
  FAILED_CONNECTION_NOTIFICATION: '接続できませんでした。',
  INITIAL_CONNECTION_NOTIFICATION: '接続中...',
  INTERRUPTED_CONNECTION_NOTIFICATION: 'ネットワーク中断しました。 再接続中...',
  // Do not localize {Retry}; it is a placeholder for "Retry". English translation should be, "Send failed. Retry."
  RENDER_ERROR_NOTIFICATION: 'レンダリングエラーが発生しました。コンソールを確認するか、ボットの開発者に連絡してください。',
  SEND_FAILED_KEY: '送信できませんでした。{Retry}。',
  SLOW_CONNECTION_NOTIFICATION: '接続するのにはいつもより長くかかります。',
  'Chat': 'チャット',
  'Download file': 'ダウンロード',
  'Microphone off': 'マイクオン',
  'Microphone on': 'マイクオフ',
  'Listening': '聴いてます',
  'retry': '再送',
  'Retry': '{retry}',
  // Please alter this value if 'Retry' at the beginning of a sentence is written differently than at the end of a sentence.
  'Sending': '送信中',
  'Tax': '税',
  'Type your message': 'メッセージを入力してください',
  'Total': '合計',
  'VAT': '消費税',
  'Send': '送信',
  'X minutes ago': xMinutesAgo
};
exports.default = _default;